import { Actions, ActionTypes } from '@appStore/metering-points/actions';
import { MeteringPointGroup } from '@model';

export interface State {
  loaded: boolean;
  loading: boolean;
  added: boolean;
  adding: boolean;
  addedGroup: MeteringPointGroup;
  data: MeteringPointGroup[];
}

export const initialState: State = {
  loaded: false,
  loading: false,
  added: false,
  adding: false,
  addedGroup: null,
  data: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.LoadMeteringPointGroupData:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.LoadMeteringPointGroupDataSuccess:
      return { ...state, loaded: true, loading: false, data: action.payload };

    case ActionTypes.LoadMeteringPointGroupDataFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.BulkUpdateMeteringPointGroupsSuccess:
      const updatedData = state.data.map(item => {
        const bulkUpdatedItem = action.payload.filter(c => c.id === item.id);
        if (bulkUpdatedItem.length > 0) {
          return {
            ...bulkUpdatedItem[0],
            meteringPoints: [...bulkUpdatedItem[0].meteringPoints]
          } as MeteringPointGroup;
        } else {
          return item;
        }
      });

      // insert new groups
      updatedData.splice(0, 0, ...action.payload.filter(x => state.data.every(y => y.id !== x.id)));
      return { ...state, data: updatedData };

    case ActionTypes.AddMeteringPointGroup:
        return {
          ...state,
          addedGroup: null,
          added: false,
          adding: true
        };

    case ActionTypes.AddMeteringPointGroupSuccess:
      return {
        ...state,
        addedGroup: action.payload,
        data: [action.payload, ...state.data],
        added: true,
        adding: false
      };

    case ActionTypes.AddMeteringPointGroupFail:
        return {
          ...state,
          added: false,
          adding: false
        };

    case ActionTypes.UpdateMeteringPointGroupSuccess:
      const updatedItem = action.payload;
      return { ...state,  data: state.data.map(item => (item.id === updatedItem.id ? updatedItem : item)) };

    case ActionTypes.RemoveMeteringPointGroupSuccess:
      return { ...state, data: state.data.filter(item => item.id !== action.payload.id) };
    case ActionTypes.ClearMeteringPointGroups:
      return { ...state, loaded: false };
  }
  return state;
}

export const getAllMeteringPointGroups = (state: State) => state.data;
export const getMeteringPointGroupsLoaded = (state: State) => state.loaded;
export const getMeteringPointGroupsLoading = (state: State) => state.loading;
export const getAddMeteringPointGroupSuccess = (state: State) => state.added;
export const getAddedMeteringPointGroup = (state: State) => state.addedGroup;
